// extracted by mini-css-extract-plugin
module.exports = {"loader":"global-page-loader_loader__PU4nt","ripple":"global-page-loader_ripple__dfT4B"};